export default __webpack_public_path__ + "static/media/undraw_sleep_analysis_o5f9.d41c9905.svg";